





















































































import {Vue, Component, Mixins, Watch} from 'vue-property-decorator';

const {Loader} = require('google-maps');
const moment = require('moment');
const flatPicker = require('vue-flatpickr-component');
import 'flatpickr/dist/flatpickr.css';
import GIFModal from '@/components/tour/GIFModal.vue';
import AsyncImage from "@/components/AsyncImage.vue";
import DepartmentFilterDrawer from "@/views/department/DeparmentFilterDrawer.vue";
import PaginationComponentMixin from '@/mixins/PaginationComponent';
import GoogleMapStyle from "@/data/GoogleMapStyle";

@Component({
  components: {
    DepartmentFilterDrawer,
    AsyncImage,
    flatPicker,
    GIFModal
  }
})
export default class MapView extends Mixins(PaginationComponentMixin) {
  private showGIF: boolean = false;
  private isDefault: boolean = true;
  private isFilterModelActive: boolean = false;
  private viewType: string = 'fieldforce';
  private infowindow : any = '';
  private demoTourEntity: string = 'mapView';
  private lastTrackings: Array<any> = [
    {
      lat: 0,

      long: 0
    }
  ];
  private departments: Array<any> = [
    {
      lat: 0,

      long: 0
    }
  ];
  private filteredDepartments: Array<any> = [
    {
      lat: 0,

      long: 0
    }
  ];
  private GIFs: Array<any> = [
    {
      label: 'See all trackings',
      url: 'https://www.youtube.com/embed/jNQXAC9IVRw'
    },
    {
      label: 'See trackings by specific date',
      url: 'https://www.youtube.com/embed/WoM3wuI4sJQ'
    }
  ];
  private demoTourTitle: string = 'A quick demo of Map View';

  get todaysDate() {
    return moment().format('YYYY-MM-DD');
  }

  public async fetchEntityFieldForce() {
    let {data} = await this.$http.get(this.$api(`/tracking-users?created_at=${this.todaysDate}`));
    this.lastTrackings = data.trackingUsers;

    let GoogleMapsLoader = await require('google-maps');
    GoogleMapsLoader = GoogleMapsLoader.default || GoogleMapsLoader;
    GoogleMapsLoader.KEY = process.env.VUE_APP_GMAP_KEY;
    GoogleMapsLoader.load((google: any) => {
      this.initMapForFieldForce(google);
    });
  }

  public async fetchEntityDepartment() {
    let {data} = await this.$http.get(this.$api(`/departments`));

    let filteredDepartments = data.departments.filter((item: any) => item.lat  && item.long);
    this.departments = filteredDepartments;
  }

  @Watch('departments')
  public async onDepartmentUpdate(value: any) {
    this.filteredDepartments = value.filter((item: any) => item.lat && item.long);
    let GoogleMapsLoader = await require('google-maps');
    GoogleMapsLoader = GoogleMapsLoader.default || GoogleMapsLoader;
    GoogleMapsLoader.KEY = process.env.VUE_APP_GMAP_KEY;
    GoogleMapsLoader.load((google: any) => {
      this.initMapForFilteredDepartment(google);
    });
  }

  async initMapForFieldForce(google: any) {
    let map: any;
    var lat;
    var lng;
    if (this.lastTrackings[0] == undefined) {
      lat = 23.68;
      lng = 90.35;
    } else {
      lat = this.lastTrackings[this.lastTrackings.length - 1].lat;
      lng = this.lastTrackings[this.lastTrackings.length - 1].long;
    }

    let color = '#5e72e4';

    let markerlLatLongs = this.lastTrackings.map(item => {
      return {
        lat: item.lat,
        lng: item.long
      };
    });
    map = document.getElementById('map-custom');

    let myLatlng = new google.maps.LatLng(lat, lng);

    let mapOptions = {
      zoom: 7,
      scrollwheel: true,
      center: myLatlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: GoogleMapStyle
    };

    map = new google.maps.Map(map, mapOptions);

    const markers = [];


    markerlLatLongs.forEach((location, index) => {
      const markerOptions = {
        position: location,
        icon: this.checkIcon(moment().diff(moment(this.lastTrackings[index].created_at).format('lll'), 'minute')),
        map: map,
        animation: google.maps.Animation.DROP,
        title: `${this.lastTrackings[index] && this.lastTrackings[index].user ?
          this.lastTrackings[index].user.name : ''}`,
      };
      const marker = new google.maps.Marker(markerOptions);
      marker.addListener("click", async () => {
        if(this.infowindow){
          this.infowindow.close();
        }
        const contentString = await this.contentStringFieldForce(index);

        this.infowindow = new google.maps.InfoWindow({
          content: contentString,
          maxWidth: 250,
          minWidth: 250
        });
        this.infowindow.open({
          anchor: marker,
          map,
          shouldFocus: false,
        });
      });
      markers.push(marker);
    });
  }

  async initMapForFilteredDepartment(google: any) {
    let map: any;
    var lat;
    var lng;
    if (this.filteredDepartments[0] == undefined) {
      lat = 23.68;
      lng = 90.35;
    } else {
      lat = Number(this.filteredDepartments[this.filteredDepartments.length - 1].lat);
      lng = Number(this.filteredDepartments[this.filteredDepartments.length - 1].long);
    }

    let color = '#5e72e4';

    let markerlLatLongs = this.filteredDepartments.map(item => {
      return {
        lat: Number(item.lat),
        lng: Number(item.long)
      };
    });
    map = document.getElementById('map-custom');

    let myLatlng = new google.maps.LatLng(lat, lng);

    let mapOptions = {
      zoom: 7,
      scrollwheel: true,
      center: myLatlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: GoogleMapStyle
    };

    map = new google.maps.Map(map, mapOptions);

    const markers = [];

    markerlLatLongs.forEach((location, index) => {
      const markerOptions = {
        position: location,
        icon: this.checkDepartmentIcon(this.filteredDepartments[index].department_type.has_outlet),
        index: index,
        map: map,
        animation: google.maps.Animation.DROP,
        title: `${this.filteredDepartments[index].name}`,
      };
      const marker = new google.maps.Marker(markerOptions);

      marker.addListener("click", async () => {
        if (this.infowindow) {
          this.infowindow.close();
        }
        const contentString = await this.contentStringDepartment(index);
        this.infowindow = new google.maps.InfoWindow({
          content: contentString,
          minWidth: 250,
          maxWidth: 250
        });
        this.infowindow.open({
          anchor: marker,
          map,
          shouldFocus: false,
        });
      });
      markers.push(marker);
    });
  }

  private async contentStringDepartment(index: number) {
    const contentString = `
    <div id="content">
    <h1 id="firstHeading" class="firstHeading text-center text-primary">${this.filteredDepartments[index] &&
    this.filteredDepartments[index].name ? this.filteredDepartments[index].name : ''}</h1>
            <div id="bodyContent" class="d-flex justify-content-center mt-4 mb-4" >
                    <img class="avatar avatar-lg rounded-circle" src="${this.filteredDepartments[index] &&
    this.filteredDepartments[index].photo_url ?
      await this.$blob2Url(this.filteredDepartments[index].photo_url) : this.$cdn + '/img/store.png'}">
        </div>
             <h2 class="firstHeading text-center"> ${this.filteredDepartments[index] &&
    this.filteredDepartments[index].owner_name ? this.filteredDepartments[index].owner_name : ''} </h2>
             <p class="text-center"> ${this.filteredDepartments[index] &&
    this.filteredDepartments[index].phone_no ? this.filteredDepartments[index].phone_no
      : ''
    } </p>
             <p class="text-center"> ${this.filteredDepartments[index] &&
    this.filteredDepartments[index].address ?
      this.filteredDepartments[index].address
      : ''
    } </p>
        </div>
    `;
    return contentString;
  }


  private async contentStringFieldForce(index: number) {
    const contentString = `
    <div id="content" v-if="${this.lastTrackings[index] && this.lastTrackings[index].user}">
        <div id="bodyContent" class="d-flex justify-content-center mt-4 mb-4" >
                    <img class="avatar avatar-lg rounded-circle" src="${this.lastTrackings[index] &&
    this.lastTrackings[index].user &&
    this.lastTrackings[index].user.propic_url ?
      await
        this.$blob2Url(this.lastTrackings[index].user.propic_url) :
      this.$cdn + '/img/avatar.png'}">
        </div>
             <h1 id="firstHeading" class="firstHeading text-center"> ${this.lastTrackings[index] &&
    this.lastTrackings[index].user &&
    this.lastTrackings[index].user.name ? this.lastTrackings[index].user.name : ''} </h1>
             <p class="text-center"> ${this.lastTrackings[index] && this.lastTrackings[index].user &&
    this.lastTrackings[index].user.phone ?
      this.lastTrackings[index].user.phone
      : ''
    } </p>
        </div>
    `;
    return contentString;
  }


  async mounted() {
    await this.fetchEntityFieldForce();
  }

  checkIcon(created_at: any) {
    if (created_at <= 15) {
      return `${this.$cdn}/img/icons/green-walking.svg`;
    } else {
      if (created_at > 15 &&
        created_at <= 30) {
        return `${this.$cdn}/img/icons/yellow-walking.svg`
      } else {
        return `${this.$cdn}/img/icons/red-walking.svg`
      }
    }
  }

  checkDepartmentIcon(department_type: any) {
    if (department_type) {
      return `${this.$cdn}/img/icons/store.svg`;
    } else {
      return `${this.$cdn}/img/icons/warehouse.svg`
    }
  }
}
